var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkHistoryPlaceholder = function SvgWorkHistoryPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.092 0a1.37 1.37 0 0 0-1.363 1.363v.455H1.366C.62 1.818 0 2.436 0 3.183v1.144l5 2 5-1.999V3.183c0-.747-.617-1.365-1.364-1.365H7.273v-.455A1.37 1.37 0 0 0 5.91 0zm0 .909H5.91c.26 0 .454.195.454.454v.455H3.637v-.455c0-.26.195-.454.455-.454m.909 3.636a.454.454 0 1 1 0 .909.454.454 0 0 1 0-.91M0 5.305v3.33C0 9.382.619 10 1.366 10h7.27C9.383 10 10 9.382 10 8.635V5.306L5.17 7.24a.45.45 0 0 1-.338 0z",
    clipRule: "evenodd"
  })));
};
export default SvgWorkHistoryPlaceholder;